var map = {
	"./button-sound.mp3": 7414,
	"./correct-answer.mp3": 4973,
	"./music-1.mp3": 804,
	"./music-2.mp3": 1973,
	"./music-3.mp3": 7535,
	"./music-4.mp3": 6533,
	"./music-5.mp3": 8242,
	"./music-6.mp3": 8941,
	"./stars-falling.mp3": 2591,
	"./wrong-answer.mp3": 1857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7018;